import { render, staticRenderFns } from "./SearchUsersThreads.vue?vue&type=template&id=0b965ca4&scoped=true&"
import script from "./SearchUsersThreads.vue?vue&type=script&lang=js&"
export * from "./SearchUsersThreads.vue?vue&type=script&lang=js&"
import style0 from "./SearchUsersThreads.vue?vue&type=style&index=0&id=0b965ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b965ca4",
  null
  
)

export default component.exports